import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useIntl } from 'react-intl';
import clsx from "clsx";
import styled from "styled-components";
import Button from '../../components/Button';
import StyledText from '../../components/StyledText'

const messageType = ({ type, email = '', intl, navigate }) => {
  let message = null;

  switch (type) {
    case 'confirmed':
      message = (
        <>
          <StyledText as="p" variant="B1">{intl.formatMessage({ id: 'an_access_email_has_sent_to' })}</StyledText>
          <StyledText as="p" variant="B1" className="emailText">{email}</StyledText>
          <StyledText as="p" variant="B1">{intl.formatMessage({ id: 'you_can_close_this_tab' })}</StyledText>
        </>
      );
      break;
    case 'inValid':
      message = (
        <>
          <StyledText as="p" variant="B1">
            {intl.formatMessage({ id: 'the_email_address_entered_does_not_match_your_unique_link_please_ensure_it_is_the_same_as_your_invitation_email' })}
          </StyledText>
          <div className='emailContainer'><StyledText as="span" variant="B1">{intl.formatMessage({ id: 'email_entered' })}</StyledText> : <StyledText as="span" variant="B1" className="emailText">{email}</StyledText></div>
        </>
      );
      break;
    case 'expired':
      message = (
        <>
          <StyledText as="p" variant="B1">
            {intl.formatMessage({
              id: 'the_feedback_portal_link_has_now_expired',
            })}
          </StyledText>
          <StyledText as="p" variant="B1">
            {intl.formatMessage({
              id: 'please_contact_your_programme_administrator_if_you_still_require_access',
            })}
          </StyledText>
          <div>
            <Button variant="primary" htmlType="submit" onClick={() => navigate(-1)}>
              {intl.formatMessage({ id: 'try_again' })}
            </Button>
          </div>
        </>
      );
      break;
    default:
      message = '';
      break;
  }

  return <>{message}</>;
};

const ConfirmationComponent = ({ className }) => {
  const intl = useIntl();
  const baseClassName = clsx("verificationComponent", className);
  const navigate = useNavigate();
  const location = useLocation();
  const email = window.sessionStorage.getItem('verificationEmail');
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get("type");
  return <div className={baseClassName}>{messageType({ type, email, intl, navigate })}</div>;
};

const StyledConfirmationComponent = styled(ConfirmationComponent)`
  &.verificationComponent {
    text-align: center;
    margin-top: 70px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
    height: 50vh;
    .contentContainer{
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
}

.emailContainer{
  display: flex;
  align-items: center;
  gap: 5px;
}
.title {
  color: #00aa9d;
  font-size: 30px;
}

.subtitle {
  color: #3c3c3c;
  font-size: 20px;
}

.email {
  width: 250px;
  margin: auto;
  margin-bottom: 20px;
  margin-top: 20px;
}

.emailBtn {
  margin-bottom: 20px;
  display: inline-block;
  font-weight: 700;
}

.emailText {
  color: #5271FF;
}
}
`;

export default StyledConfirmationComponent;
